var map = {
	"../pages/account/account.module": [
		542,
		12
	],
	"../pages/address/address.module": [
		544,
		11
	],
	"../pages/basket/basket.module": [
		543,
		10
	],
	"../pages/category/category.module": [
		546,
		9
	],
	"../pages/contact/contact.module": [
		545,
		8
	],
	"../pages/detail/detail.module": [
		547,
		7
	],
	"../pages/forgotpswd/forgotpswd.module": [
		548,
		6
	],
	"../pages/login/login.module": [
		549,
		5
	],
	"../pages/my-order/my-order.module": [
		550,
		4
	],
	"../pages/my-orders/my-orders.module": [
		551,
		3
	],
	"../pages/order/order.module": [
		554,
		2
	],
	"../pages/register/register.module": [
		552,
		1
	],
	"../pages/search/search.module": [
		553,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 267;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 267
// module chunks = 13